import { css } from 'styled-components';

/*
  для multiline троеточия используется -webkit-box и -webkit-line-clamp и
  -webkit-box-orient: https://developer.mozilla.org/en-US/docs/Web/CSS/-webkit-line-clamp;
  display: inline-block - фикс для IE11
*/
export const textOverflowLineClamp = (lineCount: number) => css`
      display: inline-block;
      display: -webkit-box;
      -webkit-line-clamp: ${lineCount};
      -webkit-box-orient: vertical;
      width: 100%;
      word-wrap: break-word;
      white-space: normal;
      overflow: hidden;
      text-overflow: ellipsis;
`;
